import { render, staticRenderFns } from "./Accomplishments.vue?vue&type=template&id=b6f400f2&"
import script from "./Accomplishments.vue?vue&type=script&lang=js&"
export * from "./Accomplishments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports